import clsx from "clsx";
import Flex, { ALIGN_CLASS, GAP_CLASS } from "components/Flex";
import UserAvatar from "components/UserAvatar";
import { arrayOf, number, shape, string } from "prop-types";

import classes from "./AvatarGroup.module.scss";
import { compareByAssignedAt } from "./helpers";

const AvatarGroup = ({
  assignees = [],
  max = 3,
  emptyLabel = "Not Assigned",
  className,
  emptyClassName,
}) => {
  const sortedAssignees = [...assignees].sort(compareByAssignedAt);
  const isOverflowing = sortedAssignees.length > max;
  const visibleCount = isOverflowing
    ? Math.max(max - 1, 0)
    : sortedAssignees.length;
  const visibleAssignees = sortedAssignees.slice(0, visibleCount);
  const overflowCount = sortedAssignees.length - visibleAssignees.length;

  return (
    <Flex
      alignItems={ALIGN_CLASS.center}
      gap={GAP_CLASS.GAP_0}
      className={clsx(classes.avatar_group, className)}
    >
      {assignees.length === 0 && (
        <span className={clsx(classes.avatar_group__empty, emptyClassName)}>
          {emptyLabel}
        </span>
      )}

      {visibleAssignees.map((assignee) => (
        <UserAvatar
          key={assignee.workspaceUserId}
          className={classes.avatar_group__item}
          user={assignee}
        />
      ))}

      {overflowCount > 0 && (
        <span
          className={clsx(
            classes.avatar_group__overflow,
            classes.avatar_group__item
          )}
          data-testid="avatar-group-overflow"
        >{`+${overflowCount}`}</span>
      )}
    </Flex>
  );
};

AvatarGroup.propTypes = {
  assignees: arrayOf(
    shape({
      workspaceUserId: number.isRequired,
      userName: string,
      firstName: string,
      lastName: string,
      assignedAt: string,
    })
  ),
  max: number,
  emptyLabel: string,
  className: string,
  emptyClassName: string,
};

export default AvatarGroup;
